import { render, staticRenderFns } from "./GroupGridOptions.vue?vue&type=template&id=74dfdec0&scoped=true&"
import script from "./GroupGridOptions.vue?vue&type=script&lang=ts&"
export * from "./GroupGridOptions.vue?vue&type=script&lang=ts&"
import style0 from "./GroupGridOptions.vue?vue&type=style&index=0&id=74dfdec0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74dfdec0",
  null
  
)

export default component.exports